export default [
  {
    name: 'update',
    path: '/update',
    component: () => import('@/pages/update/Update.vue'),
  },
]
